export enum StorageKey {
  ACCESS_TOKEN = "accessToken",
  REFRESH_TOKEN = "refreshToken",
  ACCESS_TOKEN_HM = "accessTokenHM",
  REFRESH_TOKEN_HM = "refreshTokenHM",
  EXPIRY_DATE = "expiryDate",
  TOKEN = "token",
  USERNAME = "username",
  CONFIG = "config",
}
